import { Box, Button, TextField, Typography } from '@mui/material'
import { compose, always, andThen, F, pipe, T } from 'ramda'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useState } from 'react'
import { ClearIcon } from '@mui/x-date-pickers'
import CheckIcon from '@mui/icons-material/Check'
import { EditIcon } from 'src/v3/core/icons'
import {
  errorMessageChanged,
  fetchLinkedServices,
  selectActiveLinkedService,
  selectLinkedServiceById,
} from '../manage.slice'

export default () => {
  let dispatch = useAppDispatch()
  let activeLinkedService = useAppSelector(selectActiveLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(activeLinkedService),
  )
  let [editingName, setEditingName] = useState<boolean>(false)
  let [newName, setNewName] = useState<string>(linkedService?.name || '')

  let onLinkedServiceNameChanged = () => {
    if (newName) {
      return axios
        .put('/api/manage/linked-service/name', {
          id: activeLinkedService,
          name: newName,
        })
        .then(() => {
          dispatch(fetchLinkedServices())
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
        })
    }
    return Promise.resolve()
  }

  return (
    <Box>
      {editingName ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextField
            label="Service Name"
            fullWidth
            variant="outlined"
            size="small"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            sx={{ flex: 1 }}
          />
          <Button
            color="error"
            size="small"
            onClick={pipe(
              compose(setNewName, always('')),
              compose(setEditingName, F),
            )}
          >
            <ClearIcon />
          </Button>
          <Button
            color="success"
            size="small"
            onClick={pipe(
              onLinkedServiceNameChanged,
              andThen(compose(setEditingName, F)),
            )}
          >
            <CheckIcon />
          </Button>
        </Box>
      ) : (
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
            Service Name
          </Typography>
          <Typography variant="h6" sx={{ mb: 2 }}>
            {linkedService?.name || 'No service selected'}
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<EditIcon />}
            onClick={compose(setEditingName, T)}
            sx={{ textTransform: 'none' }}
            disabled={!linkedService}
          >
            Edit Name
          </Button>
        </Box>
      )}
    </Box>
  )
}
